module.exports = __webpack_public_path__ + "media/customizations/tradition/logo-new-7ac0b6404e3bf8c099ec4d6a79225a7a.png";